/**
 * Modo manutenção do QG.
 * Ativo somente quando VITE_MAINTENANCE_MODE é exatamente "true" (trim + lowercase).
 * Ausente, vazio ou "false" mantêm o portal acessível.
 */
export function isMaintenanceMode(): boolean {
  const raw = import.meta.env.VITE_MAINTENANCE_MODE
  if (typeof raw !== 'string') return false
  return raw.trim().toLowerCase() === 'true'
}
